import { render } from "./RadioButton.vue?vue&type=template&id=01d87d40"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"
script.render = render

export default script